import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { BUTTON_LAYOUTS, BUTTON_SIZES, BUTTON_TYPES } from '../button/Button.constants';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { TestIDs } from '../../../../constants/testIDs.constants';
import { ButtonProps } from '../button/Button.types';

export enum ACTION_BUTTON_MODE {
  LABEL = 'label',
  ICON_ONLY = 'icon-only',
}

export type QuaternaryActionButtonProps = {
  text: string;
  iconName: ICON_NAMES;
  mode: ACTION_BUTTON_MODE;
  onPress?: (...args: any[]) => Promise<void>;
  size?: BUTTON_SIZES;
  type?: BUTTON_TYPES;
  layout?: BUTTON_LAYOUTS;
  disabled?: boolean;
  testID?: TestIDs | string;
  textNumberOfLines?: number;
  focusId: string;
  focusOrder: number;
  focusGroup: FocusGroups;
} & ButtonProps;
